import React, { useEffect, useState } from "react";
import {
    Grid,
    Typography,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    InputLabel,
    Select,
    Checkbox,
    ListItemText
} from "@mui/material";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import PhoneInput from "react-phone-input-2";
// import { makeStyles } from "@mui/styles";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
// import SearchIcon from "@mui/icons-material/Search";
import SearchIcon from "@mui/icons-material/Search";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { NavLink, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { countries } from "../../utils/countriesDropdown";
import {
    getCustomerList
} from "../../redux/actions/getCustomerListAction";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import EditIcon from "@mui/icons-material/Edit";
// import EditIcon from "@mui/icons-material/Edit";

import VisibilityIcon from "@mui/icons-material/Visibility";
import {
    updateCustomerDetails
} from "../../redux/actions/updateCustomerDetails";
// import BlockIcon from "@mui/icons-material/Block";
import BlockIcon from "@mui/icons-material/Block"
import CommonLogout from "../../components/CommonLogout/CommonLogout";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import Util from "../../validation";
import {

    getCustomerIdAndNameList
} from "../../redux/actions/getCustomerIdAndNameListAction";
import { Tooltip } from "antd";
// import Tooltip from "@mui/material/Tooltip";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { getUsernameContactSuggestion } from "../../redux/actions/getUsernameContactSuggestionAction";
// import Autocomplete from "@mui/material/lab/Autocomplete";
// import Tooltip from "@mui/material/Tooltip";
import Autocomplete from "@mui/material/Autocomplete";
import { resetGetCustomerbankdetails, getCustomerbankDetailsReq } from "../../redux/actions/getCustomerBankDetailsAction";
import { GetViewCustomersBankdetailsList } from "../../redux/actions/getViewCustomerBankDetailsAction";
//new
import {
    getRegenerateToken,
    resetRegenerateToken,
} from "../../redux/actions/regenerateTokenAction";
import { updateCustomerBankDetailsReq, resetUpdateCustomerBankDetails } from "../../redux/actions/updateOrAddCustomerBankDetailsAction";

import { customerCurrencyDropdown } from "../../utils/customerCurrencyDropdown";
import { getDefaultCurrencyList } from "../../redux/actions/adminCurrencyListAction";


const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const CustomerBanks = () => {
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useHistory();
    const [pageToggle, setPageToggle] = useState(false);
    const [btnAction, setbBtnAction] = useState("");
    const [open, setOpen] = React.useState(false);
    const [editOpen, setEditOpen] = React.useState(false);
    const [updateOpen, setUpdateOpen] = React.useState(false);
    const classes = useStyles();
    const dispatch = useDispatch();
    const [getCustomerId, setGetCustomerId] = useState("");
    const [customername, setCustomername] = useState("");
    const [notificationOpen, setNotificationOpen] = React.useState(false);
    const [autocompleteCustomerIDData, setautocompleteCustomerIDData] =
        useState("");
    const regenerateTokenRes = useSelector(({ regenerateToken }) => regenerateToken);
    const [getWalletOwnerBankDetailsStatus, setgetWalletOwnerBankDetailsStatus] =
        useState(false);
    var authToken = regenerateTokenRes.data.AuthToken;
    const getCustomerIdAndNameListRes = useSelector(
        ({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
    );
    const getCustomerBankDetailsListRes = useSelector(
        ({ getCustomerbankDetailsLists }) => getCustomerbankDetailsLists
    );
    const getViewCustomerBankDetailsListRes = useSelector(
        ({ getViewCustomerBankdetailslists }) => getViewCustomerBankdetailslists
    );
    console.log("viewwss", getViewCustomerBankDetailsListRes);
    const updateOrAddCustomerbankdetailsRes = useSelector(
        ({ updateOrAddcustomerbankDetailsLists }) => updateOrAddcustomerbankDetailsLists
    );
    const adminCurrencyList = useSelector(
        ({ adminCurrencyList }) => adminCurrencyList
    );

    const [bankname, setbankname] = useState("");
    const [getWalletOwnerBankDetailsRes, setgetWalletOwnerBankDetailsRes] =
        useState("");
    const [getViewWalletOwnerBankResStatus, setgetViewWalletOwnerBankResStatus] =
        useState(false);
    const [getViewWalletOwnerBankRes, setgetViewWalletOwnerBankRes] =
        useState("");
    const [editOwnerBankDetailsStatus, setEditOwnerBankDetailsStatus] =
        useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [page, setPage] = useState(0);
    const currencyList = customerCurrencyDropdown.map(item => item.currency);
    const [currency, setCurrency] = useState([]);
    // For search filter (single select)
    const [searchCurrency, setSearchCurrency] = useState("")

    const [updateoraddwalletdetailsResp, setUpdateoraddwalletdetailsResp] =
        useState("");
    const [updateoraddwalletStatus, setUpdateoraddwalletStatus] = useState(false);

    const [BankId, setBankId] = useState("");
    const [BankName, setBankName] = useState("");
    // const [currency, setCurrency] = useState("");
    const [accountNumber, setAccountNumber] = useState("");
    const [SFBCode, setSFBCode] = useState("");
    const [sortCode, setSortCode] = useState("");
    const [routingCode, setRoutingCode] = useState("");
    const [IBANNumber, setIBANNumber] = useState("");
    const [accountHolder, setAccountHolder] = useState("");
    const [bankCountry, setBankCountry] = useState("");
    const [bankAddress, setBankAddress] = useState("");
    const [zipCode, setZipCode] = useState("");
    const [bcontactNumber, setBContactNumber] = useState("");
    const [BcontactPerson, setBcontactPerson] = useState("");
    const [isBankDefault, setIsBankDefault] = useState("");
    const [CustomerID, setCustomerId] = useState("")

    // const currencyListData = customerCurrencyDropdown.map(item => item.currency);
    // console.log("currencyListData", currencyListData)
    const handleCurrencyChange = (event) => {
        const value = event.target.value;
        if (value.includes("all")) {
            // Toggle all: if all are selected, deselect all; otherwise select all
            setCurrency(
                currency.length === currencyListData.length ? [] : currencyListData
            );
        } else {
            setCurrency(value);
        }
    };
    const handleChange = ({ target: { name, value } }) => {
        if (name == "getCustomerId") {
            // console.log("CustIDDDD", getCustomerId)
            setGetCustomerId(value);
            // 	// Util.verifyNumber(value)
            // 	// 	? setCustomerid(value)
            // 	// 	: setCustomerid(customerid);
        }
        if (name === "bankname") {
            // setbankname(value);
            Util.alphaNumeric(value) ? setbankname(value) : setbankname(bankname);
        }

        if (name === "BankName") {
            // setBankName(value);
            Util.alphaNumeric(value) ? setBankName(value) : setBankName(BankName);
        }
        if (name === "accountNumber") {
            // setAccountNumber(value);
            Util.verifyMobile(value)
                ? setAccountNumber(value)
                : setAccountNumber(accountNumber);
        }


        if (name === "zipCode") {
            setZipCode(value);
            Util.verifyMobile(value) ? setZipCode(value) : setZipCode(zipCode);
        }


        if (name === "SFBCode") {
            // setSFBCode(value);
            Util.alphaNumeric(value) ? setSFBCode(value) : setSFBCode(SFBCode);
        }

        if (name === "sortCode") {
            // setSortCode(value);
            Util.verifyMobile(value) ? setSortCode(value) : setSortCode(sortCode);
        }

        if (name === "routingCode") {
            // setRoutingCode(value);
            Util.verifyMobile(value)
                ? setRoutingCode(value)
                : setRoutingCode(routingCode);
        }

        if (name === "IBANNumber") {
            // setIBANNumber(value);
            Util.verifyMobile(value)
                ? setIBANNumber(value)
                : setIBANNumber(IBANNumber);
        }

        if (name === "accountHolder") {
            // setAccountHolder(value);
            Util.verifyAlphabet(value)
                ? setAccountHolder(value)
                : setAccountHolder(accountHolder);
        }
        if (name === "bankAddress") {
            // setBankAddress(value);
            Util.verifyAlphabet(value)
                ? setBankAddress(value)
                : setBankAddress(bankAddress);
        }
        if (name === "bankCountry") {
            // setBankCountry(value);
            Util.verifyAlphabet(value)
                ? setBankCountry(value)
                : setBankCountry(bankCountry);
        }

    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleClose = () => {
        if (editOpen) {
            setOpen(false);
            setUpdateOpen(false);
            setEditOpen(false);
        } else if (open) {
            setOpen(false);
            setUpdateOpen(false);
            setEditOpen(false);
        } else if (updateOpen) {
            setOpen(false);
            setUpdateOpen(false);
            setEditOpen(false);
        }
    }

    const handleChangeRowsPerPage = (event) => {
        const newRowsPerPage = parseInt(event.target.value, 10);
        const currentFirstRowIndex = page * rowsPerPage;
        const newPage = Math.floor(currentFirstRowIndex / newRowsPerPage);

        setRowsPerPage(newRowsPerPage);
        setPage(newPage);
    };


    useEffect(() => {
        if (regenerateTokenRes.data.status === "success") {
            dispatch(getDefaultCurrencyList({
                loginDetails: {
                    walletOwnerId: regenerateTokenRes.data.partnerId || "",
                }
            }, authToken));
        }
    }, [regenerateTokenRes.data.status]);





    const currencyListData =
        adminCurrencyList?.success &&
            adminCurrencyList?.data?.status === "success"
            ? [].concat(adminCurrencyList.data.currencyList || [])
            : [];



    useEffect(() => {
        if (getCustomerIdAndNameListRes.data.status === "Success") {
            // console.log("lissttt", getCustomerIdAndNameListRes.data.currencyList)
        }
    }, [getCustomerIdAndNameListRes.data.status])

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            const getCustomerIdAndNameReq = {
                loginDetails: {
                    walletOwnerId: regenerateTokenRes.data.partnerId || ""
                },
                actionCustomerMasterRequestVO: {
                    customerNameOrId: ""
                }
            };

            dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
        }
    }, [regenerateTokenRes.data.status]);

    const filterOptionsL = (options, { inputValue }) => {
        if (inputValue.length < 3) {
            return [];
        }

        const filterOptionsList = options.filter(
            (option) =>
                option.includes(inputValue) ||
                ""
        );

        return filterOptionsList.slice(0, 20);
    }

    const GetCustomerBankDetailsRequest = () => {
        setIsLoading(true);
        setgetWalletOwnerBankDetailsStatus(true);
        const getWalletOwnerBankListReq = {
            loginDetails: {
                walletOwnerId: regenerateTokenRes.data.partnerId || "",
                customerId: autocompleteCustomerIDData ? autocompleteCustomerIDData.split('-')[0] : "",

            },
            actionCustomerMasterRequestVO: {
                bankName: bankname,
                currency: searchCurrency
            }
        };

        return dispatch(
            getCustomerbankDetailsReq(getWalletOwnerBankListReq, authToken)
        );
    };

    useEffect(() => {
        if (getWalletOwnerBankDetailsStatus) {
            getWalletOwnerBankDetailsListFun();
        }
    }, [getCustomerBankDetailsListRes.data.status]);

    const getWalletOwnerBankDetailsListFun = () => {
        if (getWalletOwnerBankDetailsStatus) {
            if (getCustomerBankDetailsListRes.data.status == "success") {
                setgetWalletOwnerBankDetailsRes([].concat(
                    getCustomerBankDetailsListRes.data.bankDetailsVO
                ));

                setIsLoading(false);
            }
            if (getCustomerBankDetailsListRes.data.status == "Failed") {
                NotificationPopups("error", "Failed", getCustomerBankDetailsListRes.data.description);
                setIsLoading(false);
                setgetWalletOwnerBankDetailsRes(getCustomerBankDetailsListRes.data);

                if (
                    getCustomerBankDetailsListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getCustomerBankDetailsListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getCustomerBankDetailsListRes.data.status == "failed") {
                NotificationPopups("error", "Failed", getCustomerBankDetailsListRes.data.description);
                setIsLoading(false);
                setgetWalletOwnerBankDetailsRes(getCustomerBankDetailsListRes.data);

                if (
                    getCustomerBankDetailsListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getCustomerBankDetailsListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getCustomerBankDetailsListRes.data.status == "Fail") {
                NotificationPopups("error", "Failed", getCustomerBankDetailsListRes.data.description);
                setIsLoading(false);
                setgetWalletOwnerBankDetailsRes(getCustomerBankDetailsListRes.data);

                if (
                    getCustomerBankDetailsListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getCustomerBankDetailsListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getCustomerBankDetailsListRes.data.status == "Not Found") {
                setgetWalletOwnerBankDetailsRes(getCustomerBankDetailsListRes.data);
                setIsLoading(false);
            }
        }
    };

    useEffect(() => {
        if (getCustomerBankDetailsListRes.data.status == "success") {
            setPage(0);
        }
    }, [getCustomerBankDetailsListRes.data.status]);


    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            GetCustomerBankDetailsRequest();
        }
    }, [regenerateTokenRes.data.AuthToken]);

    const updateHandleClickOpen = (bankId, customerId, View) => {
        setbBtnAction(View);
        setBankId(bankId);
        setCustomerId(customerId);

        customerBankViewDetails(bankId, customerId);
    };




    const customerBankViewDetails = (bankId, customerId) => {
        setgetViewWalletOwnerBankResStatus(true);
        const getWalletOwnerBankViewReq = {
            loginDetails: {
                walletOwnerId: regenerateTokenRes.data.partnerId || "",
                customerId: customerId || "",

            },
            actionCustomerMasterRequestVO: {
                bankId: bankId
            }
        };

        return dispatch(
            GetViewCustomersBankdetailsList(getWalletOwnerBankViewReq, authToken)
        );
    };


    useEffect(() => {
        if (getViewWalletOwnerBankResStatus) {
            setUpdateOpen(false);
            setEditOpen(false);
            setOpen(true);
            if (getViewCustomerBankDetailsListRes.data.status == "Success") {
                setAccountHolder(
                    getViewCustomerBankDetailsListRes.data.hashDataList.accountHolder
                );
                setAccountNumber(
                    getViewCustomerBankDetailsListRes.data.hashDataList.accountNumber
                );
                setBankAddress(
                    getViewCustomerBankDetailsListRes.data.hashDataList.bankAddress
                );

                setBContactNumber(
                    getViewCustomerBankDetailsListRes.data.hashDataList.bankContactNo
                );
                setBcontactPerson(
                    getViewCustomerBankDetailsListRes.data.hashDataList.bankContactPerson
                );
                setBankCountry(
                    getViewCustomerBankDetailsListRes.data.hashDataList.bankCountry
                );
                const bankCurrency = getViewCustomerBankDetailsListRes.data.hashDataList.bankCurrency;
                setCurrency(
                    Array.isArray(bankCurrency)
                        ? bankCurrency
                        : bankCurrency ? [bankCurrency] : []
                );

                // setCurrency(
                //     getViewCustomerBankDetailsListRes.data.hashDataList.bankCurrency
                // );
                setBankName(
                    getViewCustomerBankDetailsListRes.data.hashDataList.bankName
                );
                setZipCode(getViewCustomerBankDetailsListRes.data.hashDataList.bankZip);

                setIBANNumber(
                    getViewCustomerBankDetailsListRes.data.hashDataList.ibanNumber
                );
                setSFBCode(getViewCustomerBankDetailsListRes.data.hashDataList.ifscCode);
                setIsBankDefault(
                    getViewCustomerBankDetailsListRes.data.hashDataList.isBankDefault
                );

                setRoutingCode(
                    getViewCustomerBankDetailsListRes.data.hashDataList.routingCode
                );
                setSortCode(
                    getViewCustomerBankDetailsListRes.data.hashDataList.sortCode
                );

                setgetViewWalletOwnerBankRes(getViewCustomerBankDetailsListRes.data);
                setOpen(true);
            }
            if (getViewCustomerBankDetailsListRes.data.status == "Failed") {
                setgetViewWalletOwnerBankRes(getViewCustomerBankDetailsListRes.data);
                if (
                    getViewCustomerBankDetailsListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getViewCustomerBankDetailsListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getViewCustomerBankDetailsListRes.data.status == "failed") {
                setgetViewWalletOwnerBankRes(getViewCustomerBankDetailsListRes.data);
                if (
                    getViewCustomerBankDetailsListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getViewCustomerBankDetailsListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getViewCustomerBankDetailsListRes.data.status == "Not Found") {
                setgetViewWalletOwnerBankRes(getViewCustomerBankDetailsListRes.data);
            }
        }
    }, [getViewCustomerBankDetailsListRes.data.status]);



    //Update list
    const updateEditHandleClick = (bankId, customerId, Edit) => {
        setbBtnAction(Edit);
        setOpen(false);
        setUpdateOpen(false);
        setEditOpen(true);
        setBankId(bankId);
        setCustomerId(customerId);
        setEditOwnerBankDetailsStatus(true);
        customerBankViewDetails(bankId, customerId);
    };

    useEffect(() => {
        if (editOwnerBankDetailsStatus) {
            setOpen(false);
            if (getViewCustomerBankDetailsListRes.data.status == "Success") {
                setEditOpen(true);
                setAccountHolder(
                    getViewCustomerBankDetailsListRes.data.hashDataList.accountHolder
                );
                setAccountNumber(
                    getViewCustomerBankDetailsListRes.data.hashDataList.accountNumber
                );
                setBankAddress(
                    getViewCustomerBankDetailsListRes.data.hashDataList.bankAddress
                );

                setBContactNumber(
                    getViewCustomerBankDetailsListRes.data.hashDataList.bankContactNo
                );
                setBcontactPerson(
                    getViewCustomerBankDetailsListRes.data.hashDataList.bankContactPerson
                );
                setBankCountry(
                    getViewCustomerBankDetailsListRes.data.hashDataList.bankCountry
                );

                const bankCurrency =                                             // ✅ safe
                    getViewCustomerBankDetailsListRes.data.hashDataList.bankCurrency;
                setCurrency(
                    Array.isArray(bankCurrency) ? bankCurrency : bankCurrency ? [bankCurrency] : [])

                // setCurrency(
                //     getViewCustomerBankDetailsListRes.data.hashDataList.bankCurrency
                // );
                setBankName(
                    getViewCustomerBankDetailsListRes.data.hashDataList.bankName
                );
                setZipCode(getViewCustomerBankDetailsListRes.data.hashDataList.bankZip);

                setIBANNumber(
                    getViewCustomerBankDetailsListRes.data.hashDataList.ibanNumber
                );
                setSFBCode(getViewCustomerBankDetailsListRes.data.hashDataList.ifscCode);
                setIsBankDefault(
                    getViewCustomerBankDetailsListRes.data.hashDataList.isBankDefault
                );

                setRoutingCode(
                    getViewCustomerBankDetailsListRes.data.hashDataList.routingCode
                );
                setSortCode(
                    getViewCustomerBankDetailsListRes.data.hashDataList.sortCode
                );

                setgetViewWalletOwnerBankRes(getViewCustomerBankDetailsListRes.data);
                setOpen(true);
            }
            if (getViewCustomerBankDetailsListRes.data.status == "Failed") {
                setgetViewWalletOwnerBankRes(getViewCustomerBankDetailsListRes.data);
                if (
                    getViewCustomerBankDetailsListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getViewCustomerBankDetailsListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getViewCustomerBankDetailsListRes.data.status == "failed") {
                setgetViewWalletOwnerBankRes(getViewCustomerBankDetailsListRes.data);
                if (
                    getViewCustomerBankDetailsListRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getViewCustomerBankDetailsListRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (getViewCustomerBankDetailsListRes.data.status == "Not Found") {
                setgetViewWalletOwnerBankRes(getViewCustomerBankDetailsListRes.data);
            }
        }
    }, [getViewCustomerBankDetailsListRes.data.status]);

    const updateBankDetails = () => {
        setUpdateoraddwalletStatus(true);
        const updateWalletOwnerBankViewReq = {
            loginDetails: {
                walletOwnerId: regenerateTokenRes.data.partnerId || "",
                customerId: getViewCustomerBankDetailsListRes.data.hashDataList.customerId || "",
            },
            bankDetailsVO: {
                bankId: BankId,
                accountHolder: accountHolder,
                accountNumber: accountNumber,
                bankAddress: bankAddress,
                bankContactNo: bcontactNumber,
                bankContactPerson: BcontactPerson,
                bankCountry: bankCountry,
                bankCurrency: currency,
                bankName: BankName,
                bankZip: zipCode,
                ibanNumber: IBANNumber,
                ifscCode: SFBCode,
                isBankDefault: isBankDefault,
                routingCode: routingCode,
                sortCode: sortCode
            }
        };

        return dispatch(
            updateCustomerBankDetailsReq(updateWalletOwnerBankViewReq, authToken)
        );
    };


    useEffect(() => {
        if (updateoraddwalletStatus) {
            if (updateOrAddCustomerbankdetailsRes.data.status == "success") {
                setUpdateoraddwalletdetailsResp(
                    updateOrAddCustomerbankdetailsRes.data
                );

                setUpdateOpen(true);
                GetCustomerBankDetailsRequest()
                setOpen(false);
                setEditOpen(false);
            }
            if (updateOrAddCustomerbankdetailsRes.data.status == "Failed") {
                setUpdateoraddwalletdetailsResp(
                    updateOrAddCustomerbankdetailsRes.data
                );
                setUpdateOpen(true);
                setOpen(false);
                setEditOpen(false);
                if (
                    updateOrAddCustomerbankdetailsRes.data.description ==
                    "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    updateOrAddCustomerbankdetailsRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (updateOrAddCustomerbankdetailsRes.data.status == "failed") {
                setUpdateoraddwalletdetailsResp(
                    updateOrAddCustomerbankdetailsRes.data
                );
                setUpdateOpen(true);
                setOpen(false);
                setEditOpen(false);
                if (
                    updateOrAddCustomerbankdetailsRes.data.description ==
                    "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    updateOrAddCustomerbankdetailsRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
            if (updateOrAddCustomerbankdetailsRes.data.status == "Not Found") {
                setUpdateoraddwalletdetailsResp(
                    updateOrAddCustomerbankdetailsRes.data
                );
                setUpdateOpen(true);
                setOpen(false);
                setEditOpen(false);
            }
        }
    }, [updateOrAddCustomerbankdetailsRes.data.status]);

    return (
        <>

            <Layout>
                <Card>
                    <Grid
                        container
                        style={{ padding: "25px", gap: "20px", justifyContent: "right" }}
                    >
                        <Grid item md={3} sm={12} xs={12} lg={3}>
                            <NavLink to="/index/addCustomerBankDetails">

                                <CustomButton
                                    style={{
                                        padding: "8px"
                                    }}
                                >
                                    Add Bank Details
                                </CustomButton>
                            </NavLink>
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <Autocomplete
                                id="combo-box-demo"
                                options={[].concat(
                                    getCustomerIdAndNameListRes.data.currencyList || [""]
                                )}
                                getOptionLabel={(option) => option}
                                filterOptions={filterOptionsL}
                                value={autocompleteCustomerIDData}
                                onChange={(event, value) =>
                                    setautocompleteCustomerIDData(value)
                                }

                                renderInput={(params) => (

                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        id="name"

                                        label="Customer ID"
                                        // style={{ marginTop: "3px" }}
                                        // required
                                        type="text"
                                        fullWidth
                                        {...params}
                                        className="new1"
                                        // value={getCustomerId || ""}
                                        // name="getCustomerId"
                                        onBlur={handleChange}
                                        sx={{
                                            "& .MuiInput-underline:before": {
                                                borderBottomColor: "gray", // White color for the underline before focus
                                            },
                                            "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                                borderBottomColor: "gray", // White color on hover
                                            },
                                            "& .MuiInput-underline:after": {
                                                borderBottomColor: "gray", // White color after focus
                                            },
                                        }}
                                        variant="standard"
                                    />
                                )}
                            />
                        </Grid>


                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <FormControl fullWidth variant="standard" style={{ marginTop: "8px" }}>
                                <InputLabel>Currency</InputLabel>

                                <Select
                                    value={searchCurrency}
                                    onChange={(e) => setSearchCurrency(e.target.value)}
                                >
                                    <MenuItem value="">
                                        Select Currency
                                    </MenuItem>
                                    {currencyList.map((item) => (
                                        <MenuItem key={item} value={item}>
                                            {item}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="name"
                                label="Bank Name"
                                type="text"
                                fullWidth
                                variant="standard"
                                value={bankname}
                                name="bankname"
                                onChange={handleChange}
                                InputProps={{
                                    sx: {
                                        "&:before": { borderBottomColor: "gray" }, // before focus
                                        "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                }}
                                InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                    margin: "18px"
                                }}
                                onClick={GetCustomerBankDetailsRequest}
                            >
                                Search <SearchIcon />
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>

                {isLoading ? (
                    <LoadingSpinner />
                ) : getWalletOwnerBankDetailsRes.length == undefined ||
                    getWalletOwnerBankDetailsRes.status == "Failed" ||
                    getWalletOwnerBankDetailsRes.status == "Not Found" ||
                    !getWalletOwnerBankDetailsStatus ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography
                                    variant="body1"
                                    style={{ fontWeight: "700" }}
                                    className="themeText"
                                >
                                    Customer Bank Details
                                </Typography>
                            </Grid>

                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 tableHeaderColor"
                                    variant="secondary"
                                    style={{ color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography
                                    variant="body1"
                                    style={{ fontWeight: "700" }}
                                    className="themeText"
                                >
                                    Customer Banks Details  
                                </Typography>
                            </Grid>
                            <TableContainer component={Paper} className="my-3">
                                <Table
                                    className={classes.table}
                                    size="small"
                                    aria-label="a dense table"
                                >
                                    <TableHead>
                                        <TableRow className="tableHeaderColor">
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Customer ID
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Account Number
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Account Holder
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Bank Name
                                            </TableCell>
                                            {/* <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Currency
                                            </TableCell> */}
                                             <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                IBAN
                                            </TableCell>
                                             <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Swift Code
                                            </TableCell>

                                             <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Sort Code
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Action
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {getWalletOwnerBankDetailsRes &&
                                            []
                                                .concat(getWalletOwnerBankDetailsRes)
                                                .slice(
                                                    page * rowsPerPage,
                                                    page * rowsPerPage + rowsPerPage
                                                )
                                                .map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell align="center">{row.customerId}</TableCell>
                                                        <TableCell align="center">
                                                            {row.accountNumber}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.accountHolder}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.bankName}
                                                        </TableCell>
                                                        {/* <TableCell align="center">
                                                            {row.bankCurrency}
                                                        </TableCell> */}
                                                       
                                                        {/* <TableCell align="center" style={{ wordBreak: "break-word", whiteSpace: "normal" }}>
                                                            {Array.isArray(row.bankCurrency)
                                                                ? row.bankCurrency.join(",")
                                                                : row.bankCurrency || "-"}
                                                        </TableCell> */}

                                                         <TableCell align="center">
                                                            {row.ibanNumber}
                                                        </TableCell>

                                                         <TableCell align="center">
                                                            {row.ifscCode}
                                                        </TableCell>

                                                          <TableCell align="center">
                                                            {row.sortCode}
                                                        </TableCell>

                                                        <TableCell align="center" style={{ display: "flex" }}>
                                                            <Tooltip title="View">
                                                                <CustomButton
                                                                    style={{
                                                                        padding: "8px"
                                                                    }}
                                                                    onClick={() =>
                                                                        updateHandleClickOpen(row.bankId, row.customerId, "View")
                                                                    }
                                                                >
                                                                    {
                                                                        <VisibilityIcon
                                                                            style={{
                                                                                color: "#fff",
                                                                                fontSize: "20px"
                                                                            }}
                                                                        />
                                                                    }
                                                                </CustomButton>
                                                            </Tooltip>

                                                            <Tooltip title="Edit">
                                                                <CustomButton
                                                                    style={{
                                                                        padding: "8px"
                                                                    }}
                                                                    onClick={() =>
                                                                        updateEditHandleClick(row.bankId, row.customerId, "Edit")
                                                                    }
                                                                >
                                                                    {
                                                                        <EditIcon
                                                                            style={{
                                                                                color: "#fff",
                                                                                fontSize: "20px"
                                                                            }}
                                                                        />
                                                                    }
                                                                </CustomButton>
                                                            </Tooltip>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={getWalletOwnerBankDetailsRes.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </TableContainer>
                        </Grid>
                    </Card>
                )}

                {btnAction == "View" && (
                    <div>
                        <Dialog open={open} onClose={handleClose}>
                            <DialogTitle>View Customer</DialogTitle>
                            <DialogContent>
                                {/* {Object.entries(getViewWalletOwnerBankRes).map(([key, value]) => (
                              <TextField
                                autoFocus
                                margin="dense"
                                label={
                                  key
                                    ? key.replace(/([a-z])([A-Z])/, "$1 $2").toUpperCase()
                                    : ""
                                }
                                type="name"
                                fullWidth
                                variant="standard"
                                value={value || ""}
                                disabled
                              />
                            ))} */}

                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="Bank ID"
                                    type="name"
                                    fullWidth
                                    variant="standard"
                                    value={BankId || ""}
                                    disabled
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                />
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="Bank Name"
                                    type="name"
                                    fullWidth
                                    variant="standard"
                                    value={BankName || ""}
                                    disabled
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                />

                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="Currency"
                                    type="name"
                                    fullWidth
                                    variant="standard"
                                    value={currency || ""}
                                    disabled
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                />
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="Account Holder"
                                    type="name"
                                    fullWidth
                                    variant="standard"
                                    value={accountHolder || ""}
                                    disabled
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                />
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="IBAN Number"
                                    type="name"
                                    fullWidth
                                    variant="standard"
                                    value={IBANNumber || ""}
                                    disabled
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                />





                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="SWIFT/IFSC/BIC Code"
                                    type="name"
                                    fullWidth
                                    variant="standard"
                                    value={SFBCode || ""}
                                    disabled
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                />


                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="Account Number"
                                    type="name"
                                    fullWidth
                                    variant="standard"
                                    value={accountNumber || ""}
                                    disabled
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                />



                                {/* <TextField
                                autoFocus
                                margin="dense"
                                label="SWIFT/IFSC/BIC Code"
                                type="name"
                                fullWidth
                                variant="standard"
                                value={SFBCode || ""}
                                disabled
                              /> */}

                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="Sort Code"
                                    type="name"
                                    fullWidth
                                    variant="standard"
                                    value={sortCode || ""}
                                    disabled
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                />

                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="ABA Routing Code"
                                    type="name"
                                    fullWidth
                                    variant="standard"
                                    value={routingCode || ""}
                                    disabled
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                />




                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="Bank Country"
                                    type="name"
                                    fullWidth
                                    variant="standard"
                                    value={bankCountry || ""}
                                    disabled
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                />

                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="Bank Address"
                                    type="name"
                                    fullWidth
                                    variant="standard"
                                    value={bankAddress || ""}
                                    disabled
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                />

                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="Bank Zip Code"
                                    type="name"
                                    fullWidth
                                    variant="standard"
                                    value={zipCode || ""}
                                    disabled
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                />

                                {/* <TextField
                                    autoFocus
                                    margin="dense"
                                    label="Bank Contact Number"
                                    type="name"
                                    fullWidth
                                    variant="standard"
                                    value={bcontactNumber || ""}
                                    disabled
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                /> */}

                                {/* <TextField
                                    autoFocus
                                    margin="dense"
                                    label="Bank Contact Person"
                                    type="name"
                                    fullWidth
                                    variant="standard"
                                    value={BcontactPerson || ""}
                                    disabled
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                /> */}

                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="Is Bank Default"
                                    type="name"
                                    fullWidth
                                    variant="standard"
                                    value={isBankDefault || ""}
                                    disabled
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                />
                            </DialogContent>
                            <DialogActions>
                                <CustomButton
                                    style={{
                                        padding: "8px"
                                    }}
                                    onClick={handleClose}
                                >
                                    Close
                                </CustomButton>
                            </DialogActions>
                        </Dialog>
                    </div>
                )}

                {btnAction == "Edit" && (
                    <div>
                        <Dialog open={editOpen} onClose={handleClose}>
                            <DialogTitle>Update Customer</DialogTitle>
                            <DialogContent>
                                {/* {Object.entries(getViewWalletOwnerBankRes).map(([key, value]) => (
                              <TextField
                                autoFocus
                                margin="dense"
                                label={
                                  key
                                    ? key.replace(/([a-z])([A-Z])/, "$1 $2").toUpperCase()
                                    : ""
                                }
                                type="name"
                                fullWidth
                                variant="standard"
                                value={value || ""}
                                disabled
                              />
                            ))} */}

                                <TextField
                                    autoFocus
                                    name="BankName"
                                    margin="dense"
                                    label="Bank Name"
                                    type="name"
                                    fullWidth
                                    variant="standard"
                                    onChange={handleChange}
                                    value={BankName || ""}
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                />

                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="Account Holder"
                                    type="text"
                                    name="accountHolder"
                                    fullWidth
                                    variant="standard"
                                    onChange={handleChange}
                                    value={accountHolder || ""}
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                />

                                {/* <TextField
                                                select
                                                autoFocus
                                                margin="dense"
                                                label="Currency"
                                                name="currency"
                                                type="text"
                                                fullWidth
                                                variant="standard"
                                                onChange={handleChange}
                                                // value={currency || ""}
                                                defaultValue={currency || "Select Currency"}
                                                InputProps={{
                                                    sx: {
                                                      "&:before": { borderBottomColor: "gray" }, // before focus
                                                      "&:after": { borderBottomColor: "gray" },  // after focus
                                                    },
                                                  }}
                                                  InputLabelProps={{
                                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                                  }}
                                            >
                                                <MenuItem value="Select Currency" selected="Select Currency">
                                                    Select Currency
                                                </MenuItem>
                                                {adminCurrencyList.success &&
                                                    []
                                                        .concat(adminCurrencyList.data.currencyList)
                                                        .map((x) => <MenuItem value={x}>{x}</MenuItem>)}
                                            </TextField> */}

                                <TextField
                                    autoFocus
                                    name="accountNumber"
                                    margin="dense"
                                    label="Account Number"
                                    type="name"
                                    fullWidth
                                    variant="standard"
                                    onChange={handleChange}
                                    value={accountNumber || ""}
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                />

                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="SWIFT/IFSC/BIC Code"
                                    type="text"
                                    fullWidth
                                    name="SFBCode"
                                    variant="standard"
                                    onChange={handleChange}
                                    value={SFBCode || ""}
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                />

                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="Sort Code"
                                    name="sortCode"
                                    type="text"
                                    fullWidth
                                    variant="standard"
                                    onChange={handleChange}
                                    value={sortCode || ""}
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                />

                                {/* <TextField
                                    autoFocus
                                    margin="dense"
                                    label="ABA Routing Code(US)"
                                    type="text"
                                    fullWidth
                                    name="routingCode"
                                    variant="standard"
                                    onChange={handleChange}
                                    value={routingCode || ""}
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                /> */}
                                <FormControl fullWidth variant="standard">
                                    <InputLabel
                                        required
                                    >Currency</InputLabel>

                                    <Select
                                        multiple
                                        value={currency}
                                        onChange={handleCurrencyChange}
                                        renderValue={(selected) => selected.join(", ")}
                                    >
                                        {/* Select All */}
                                        <MenuItem value="all">
                                            <Checkbox
                                                checked={
                                                    currency.length === currencyListData.length &&
                                                    currencyListData.length > 0
                                                }
                                            />
                                            <ListItemText primary="All" />
                                        </MenuItem>

                                        {/* Currency List */}
                                        {currencyListData.map((item) => (
                                            <MenuItem key={item} value={item}>
                                                <Checkbox checked={currency.indexOf(item) > -1} />
                                                <ListItemText primary={item} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="IBAN Number"
                                    name="IBANNumber"
                                    type="text"
                                    fullWidth
                                    variant="standard"
                                    onChange={handleChange}
                                    value={IBANNumber || ""}
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                />


                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="Bank Country"
                                    name="bankCountry"
                                    type="text"
                                    fullWidth
                                    variant="standard"
                                    onChange={handleChange}
                                    value={bankCountry || ""}
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                />

                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="Bank Address"
                                    type="text"
                                    name="bankAddress"
                                    fullWidth
                                    variant="standard"
                                    onChange={handleChange}
                                    value={bankAddress || ""}
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                />

                                <TextField
                                    autoFocus
                                    margin="dense"
                                    label="Bank Zip Code"
                                    name="zipCode"
                                    onChange={handleChange}
                                    type="text"
                                    fullWidth
                                    variant="standard"
                                    value={zipCode || ""}
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                />

                                {/* <TextField
                                    autoFocus
                                    margin="dense"
                                    label="Bank Contact Number"
                                    type="text"
                                    name="bcontactNumber"
                                    fullWidth
                                    variant="standard"
                                    onChange={handleChange}
                                    value={bcontactNumber || ""}
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                /> */}

                                {/* <TextField
                                    autoFocus
                                    margin="dense"
                                    label="Bank Contact Person"
                                    type="text"
                                    fullWidth
                                    name="BcontactPerson"
                                    variant="standard"
                                    onChange={handleChange}
                                    value={BcontactPerson || ""}
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                /> */}

                                <TextField
                                    select
                                    autoFocus
                                    margin="dense"
                                    label="Is Bank Default"
                                    name="isBankDefault"
                                    type="text"
                                    fullWidth
                                    variant="standard"
                                    onChange={handleChange}
                                    defaultValue={isBankDefault || "Select Status"}
                                    InputProps={{
                                        sx: {
                                            "&:before": { borderBottomColor: "gray" }, // before focus
                                            "&:after": { borderBottomColor: "gray" },  // after focus
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: { color: 'gray' }, // Optional: if you want the label to be white
                                    }}
                                >
                                    <MenuItem value="Select Status">Select Status</MenuItem>
                                    <MenuItem value="Y">Y</MenuItem>
                                    <MenuItem value="N">N</MenuItem>
                                </TextField>
                            </DialogContent>
                            <DialogActions>
                                <CustomButton
                                    style={{
                                        padding: "8px"
                                    }}
                                    onClick={() => handleClose()}
                                >
                                    Close
                                </CustomButton>
                                <CustomButton
                                    style={{
                                        padding: "8px"
                                    }}
                                    onClick={() => updateBankDetails()}
                                >
                                    Save
                                </CustomButton>
                                {/* <Button
                                style={{
                                  backgroundColor: "#00b9f5",
                                  color: "white",
                                }}
                                variant="contained"
                                onClick={updateBankDetails}
                              >
                                Save
                              </Button>
                
                              <Button
                                style={{
                                  backgroundColor: "#00b9f5",
                                  color: "white",
                                }}
                                variant="contained"
                                onClick={handleClose}
                              >
                                Close
                              </Button> */}
                            </DialogActions>
                        </Dialog>
                    </div>
                )}

                {updateOpen && (
                    <div>
                        <Dialog open={updateOpen} onClose={handleClose}>
                            <DialogContent className="text-center"
                                style={{ backgroundColor: "#00b9f51c" }}

                            >
                                {updateoraddwalletdetailsResp.status == "success" ? (
                                    <img src={success} alt="" width="100px" className="my-2" />
                                ) : (
                                    <img src={failed} alt="" width="100px" className="my-2" />
                                )}
                            </DialogContent>
                            <DialogContent>
                                <h3
                                    style={{ margin: "0", fontSize: "15px", textAlign: "center" }}
                                >
                                    {updateoraddwalletdetailsResp.description}
                                </h3>
                            </DialogContent>
                            <DialogActions style={{ justifyContent: "center" }}>

                                <CustomButton
                                    style={{
                                        padding: "8px"
                                    }}
                                    onClick={handleClose}
                                >
                                    Ok
                                </CustomButton>
                            </DialogActions>
                        </Dialog>
                    </div>
                )}
            </Layout>
        </>
    )
}

export default CustomerBanks